export default "__VITE_ASSET__f199fbf9__"